<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav minColor2">产品</div></div>
                <div class="title minColor2">数据防泄漏</div>
                <div class="minTitle minColor2">通过智能化检测模型分析内外账号对敏感文件的访问行为，实现对敏感数据访问的异常检测，同时为数据安全管理团队提供相关告警。</div>
                <!-- <div class="button minColor2 button2">咨询详情</div> -->
            </div>
        </div>
        <picture>
            <source srcset="@/assets/images/sj1_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/sj1.png" />
        </picture>
       <div class="lxwm bg1">
            <div class="content">
                <div class="title1 tc">产品特点</div>
                <div class="items mt5">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/sj3.png" />
                            <div class="lb">
                                新理念
                            </div>
                        </div>
                        <div class="minTitle2">
                            数据分类分级；数据资产态势感知；智能决策辅助
                        </div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/sj4.png" />
                            <div class="lb">
                                新设计
                            </div>
                        </div>
                        <div class="minTitle2">
                            数据资产地图；内/外部威胁检测；风险发现和预测
                        </div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/sj5.png" />
                            <div class="lb">
                                新技术
                            </div>
                        </div>
                        <div class="minTitle2">
                            机器学习；自然语言处理；用户/实体行为分析
                        </div>
                    </div>
                </div>
                <div class="itemLine mt20">
                    <div class="tit">
                        <img src="@/assets/images/sj6.png" />
                        <span>领导层关注的数据资产难题！</span>
                    </div>
                    <div>
                        <div class="title4 mt5">
                            领导层关注的数据资产难题！
                        </div>
                        <div class="minTitle2 mt10">
                            <span>1: 组织拥有哪些关键数据?</span>
                            <span>2: 关键数据位于组织何处?</span>
                            <span>3: 监控敏感数据的使用和风险? </span>
                            <span>4: 应对内部威胁和外部威胁?</span>
                            <span>5: 如何满足监管机构的合规要求?</span>
                        </div>
                    </div>
                </div>
            </div>
       </div>
       <div class="botton">
            <div class="content">
                <div class="myTitle">如何应对数据安全治理挑战?</div>
                <div class="flex">
                    <div class="item">
                        <div class="maxTitle">数据分类分级已成为合规落地最佳实践</div>
                        <div class="minTitle">被各行业监管规范与合规指南广泛采用</div>
                    </div>
                    <div class="item">
                        <div class="maxTitle">先进自然语言处理技术才能支持数据分类能力</div>
                        <div class="minTitle">内容识别技术已发展至AI阶段</div>
                    </div>
                </div>
                <div class="mt10 flex">
                    <div class="item">
                        <div class="maxTitle">人工智能实现基于内容识别的数据分类分级</div>
                        <div class="minTitle">被数百万大型企业员工日常使用的成熟产品级引擎</div>
                    </div>
                    <div class="item">
                        <div class="maxTitle">全局掌控数据资产态势才能更好实施安全治理</div>
                        <div class="minTitle">基于外发安全事件的传统DLP已无法适应当今场景</div>
                    </div>
                </div>
                <div class="mt10 flex">
                    <div class="item">
                        <div class="maxTitle">安全策略覆盖数据资产常见位置</div>
                        <div class="minTitle">数据梳理-使用场景-保护动作-事件处理</div>
                    </div>
                    <div class="item">
                        <div class="maxTitle">灵活配置多维度安全策略</div>
                        <div class="minTitle">审计或阻断行为</div>
                    </div>
                </div>
                <div class="mt10 flex">
                    <div class="item">
                        <div class="maxTitle">用户行为分析与意图预测</div>
                        <div class="minTitle">风险用户象限；风险意向预测</div>
                    </div>
                    <div class="item">
                        <div class="maxTitle">详细用户风险行为报告</div>
                        <div class="minTitle">大幅提升数据安全运营团队工作效率</div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .botton {
            background: url(../../assets/images/sj2.png) no-repeat;
            background-size: 100% 100%;
            min-height: 450px;
            padding-bottom: 50px;
            .myTitle {
                font-size: 26px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                padding: 30px 0 30px;
            }
            .item {
                display: inline-block;
                border: 1px solid #3C91FF;
                padding: 20px 15px;
                width: 40%;
                margin-right: 20px;
                .maxTitle {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #3C91FF;
                }
                .minTitle {
                    margin-top: 10px;
                    font-size: 12px;
                    font-family: PingFang SC;
                    color: #ffffff;
                }
            }
        }
        .lxwm {
            padding: 30px 0;
            .itemLine {
                padding: 20px 2%;
                background-color: #FFFAE7;
                .tit span {
                    display: none;
                }
                img {
                    width: 52;
                    height: 56px;
                    float: left;
                    margin-right: 10px;
                }
                .minTitle2 {
                    span {
                        display: inline-block;
                        margin-right: 45px;
                    }
                }
            }
            .items {
                display: flex;
                flex-wrap: wrap;
                .item {
                    margin-top: 10px;
                    width: 10.66%;
                    background-color: #ffffff;
                    padding: 15px 3%;
                    text-align: center;
                    img {
                        height: 35px;
                    }
                    .lb {
                       margin-top: 10px;
                    }
                }

                .item2 {
                    margin-top: 20px;
                    width: 27.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    padding: 15px 2%;
                    min-height: 110px;
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        margin-top: 10px;
                        line-height: 20px;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
    .botton {
        .myTitle {
            text-align: center;
        }
        .flex {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            justify-content: space-between;
            .item {
                width: 43%;
                margin-right: 0;
            }
        }
    } 
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        color: #fff;
        .title {
          font-size: 20px;
        }
        .minColor2 {
            color: #fff;
            border-color: #fff;
        }
        .minTitle {
          width: 40%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    }
    
  }
}
@media (max-width: 768px) {
    .index {
        .flash {
            padding: 0 15px;
            .minTitle {
                width: 50%;
                font-size: 13px;
            }
            .gg {
                top: 50px;
                .title {
                    font-size: 20px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
            
        }
        .flashImg {
            height: 40vh;
        }
        .lxwm {
            .title1 {
                margin-top: 10px;
                margin-bottom: 0;
            }
            .items {
                justify-content: space-between;
                .item2 {
                    width: 100%;
                    margin-right: 0;
                    margin-bottom: 0;
                    padding: 30px 15px;
                    .tit {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 20px;
                        .lb {
                            line-height: normal;
                        }
                        img {
                            height: 20px;
                        }
                    }
                    .minTitle2 {
                        font-size: 14px;
                    }
                }
            }
            .itemLine {
                padding: 20px 30px;
                .minTitle2 {
                    line-height: 1.8;
                    padding: 0 15px;
                    span {
                        display: block;
                        margin-right: 0;
                        font-size: 14px;
                    }
                } 
                .title4 {
                    display: none;
                }
                .tit {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                    img {
                        width: 25px;
                        height: auto;
                    }
                    span {
                        display: inline-block;
                        font-size: 16px;
                    }
                }
            }
        }
        .botton {
            .flex {
                .item {
                    width: 100%;
                    margin-bottom: 15px;
                    padding: 25px 20px;
                    .maxTitle {
                        margin-bottom: 15px;
                        font-size: 16px;
                    }
                    .minTitle {
                        font-size: 14px;
                    }
                }
            }
            .myTitle {
                font-size: 20px;
            }
        } 
    }
}
</style>